import DRate from './src';

DRate.install = Vue => {
  Vue.component('DRate', DRate);
};

export default DRate;
